
import Stack from '@mui/joy/Stack';
import useRoles from 'hooks/useRoles';

export default function RoleStack({ role, children, spacing=0, direction="column", alignItems=undefined, justifyContent=undefined}: { role: string, children: React.ReactNode, spacing?: number, direction?: "column" | "row", alignItems?: "flex-start" | "center" | "flex-end" | "stretch" | "baseline" | undefined, justifyContent?: "flex-start" | "center" | "flex-end" | "space-between" | "space-around" | "space-evenly" | undefined}) {
    const { hasRole } = useRoles();
    if (!hasRole(role)) {
        return null;
    }

    return (
        <Stack spacing={spacing} direction={direction} alignItems={alignItems} justifyContent={justifyContent}>
            {children}
        </Stack>
    );
}
